class CollectionFilters {
  constructor() {
    this.filterButtons = document.querySelectorAll('.filter-button');
    this.filterContents = document.querySelectorAll('.filter-content');
    this.filterInputs = document.querySelectorAll('.filter-option input');
    this.sortInputs = document.querySelectorAll('input[name="sort_by"]');
    this.currentFilters = new URLSearchParams(window.location.search);
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupClickOutside();
    this.updateButtonStates();
    this.loadFromUrl();
  }

  setupEventListeners() {
    // Toggle dropdowns
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        this.closeAllDropdowns();
        if (!isExpanded) {
          this.openDropdown(button);
        }
      });
    });

    // Handle filter changes
    this.filterInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateFilters();
      });
    });

    // Handle sort changes
    this.sortInputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateSort(input.value);
      });
    });
  }

  setupClickOutside() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.filter-dropdown, .sort-dropdown')) {
        this.closeAllDropdowns();
      }
    });
  }

  openDropdown(button) {
    button.setAttribute('aria-expanded', 'true');
    const content = button.nextElementSibling;
    content.hidden = false;
  }

  closeAllDropdowns() {
    this.filterButtons.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      const content = button.nextElementSibling;
      content.hidden = true;
    });
  }

  updateFilters() {
    const formData = new FormData();
    
    // Handle price filters specially
    const priceInputs = document.querySelectorAll('input[name="filter.v.price.gte"]');
    let selectedPriceFilter = null;
    
    priceInputs.forEach(input => {
      if (input.checked) {
        selectedPriceFilter = input.value;
      }
    });
    
    // Add all checked inputs to formData
    this.filterInputs.forEach(input => {
      if (input.checked) {
        // Skip price inputs as we handle them separately
        if (input.name !== 'filter.v.price.gte') {
          formData.append(input.name, input.value);
        }
      }
    });
    
    // Add price filter if selected
    if (selectedPriceFilter !== null) {
      formData.append('filter.v.price.gte', selectedPriceFilter);
      
      // Add price range limits for better filtering
      if (selectedPriceFilter === '0') {
        formData.append('filter.v.price.lt', '5000');
      } else if (selectedPriceFilter === '5000') {
        formData.append('filter.v.price.lt', '10000');
      } else if (selectedPriceFilter === '10000') {
        formData.append('filter.v.price.lt', '20000');
      }
      // For "Over $200" we don't need an upper limit
    }

    const queryString = new URLSearchParams(formData).toString();
    const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
    
    this.updateButtonStates();
    this.refreshPage(newUrl);
  }

  updateSort(value) {
    if (value === 'relevance') {
      this.currentFilters.delete('sort_by');
    } else {
      this.currentFilters.set('sort_by', value);
    }

    const queryString = this.currentFilters.toString();
    const newUrl = `${window.location.pathname}${queryString ? '?' + queryString : ''}`;
    
    this.refreshPage(newUrl);
  }

  updateButtonStates() {
    this.filterButtons.forEach(button => {
      const dropdown = button.closest('.filter-dropdown');
      if (!dropdown) return;

      const checkedInputs = dropdown.querySelectorAll('input:checked');
      const originalText = button.textContent.split(' (')[0];
      
      if (checkedInputs.length > 0) {
        button.textContent = `${originalText} (${checkedInputs.length})`;
      } else {
        button.textContent = originalText;
      }
    });
  }

  loadFromUrl() {
    const params = new URLSearchParams(window.location.search);
    
    // Load filters
    params.forEach((value, key) => {
      const input = document.querySelector(`input[name="${key}"][value="${value}"]`);
      if (input) {
        input.checked = true;
      }
    });

    // Load sort
    const sortValue = params.get('sort_by') || 'relevance';
    const sortInput = document.querySelector(`input[name="sort_by"][value="${sortValue}"]`);
    if (sortInput) {
      sortInput.checked = true;
      // Update sort button text
      const sortButton = document.querySelector('.sort-dropdown .filter-button');
      if (sortButton) {
        sortButton.textContent = `Sort: ${sortInput.nextElementSibling.textContent}`;
      }
    }

    this.updateButtonStates();
  }

  refreshPage(url) {
    window.location.href = url;
  }
}

// Initialize filters when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
}); 